// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GlobalSearch_wrapper__j3tXM","results":"GlobalSearch_results__Eg8xC","shortcutHint":"GlobalSearch_shortcutHint__JS1s_"};